import React from "react";
import { Box, Typography } from "@mui/material";
import SectionTitle from "./SectionTitle";
import { Link as RouterLink } from "react-router-dom";
import { backendURL } from "../../constants";
import { byCalibration, pictureLabel } from "../../backend/calibration";

type DiamondGalleryProps = {
  data: any;
  // The picture shown below the strip, whose label is picked out.
  selectedImageID?: string;
};

// All of a stone's pictures, under their section title, as a full-width strip, each at the same height so they sit side by side
// at a comparable size; the width follows each image's real aspect ratio, so nothing is letterboxed
// or cropped. Shown under the header in image-analysis mode, not in the header itself.
const DiamondGallery = ({ data, selectedImageID }: DiamondGalleryProps) => {
  // Only worth a strip when there is more than one picture — a lone image is already the header's.
  const images = [...(data?.images ?? [])].sort(byCalibration);
  if (images.length <= 1) return null;

  return (
    <>
      <SectionTitle>Images</SectionTitle>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        {images.map((image: any) => (
          <Box key={image.id} sx={{ textAlign: "center" }}>
            <RouterLink
              to={"/analytics/fromimage/" + image.id}
              style={{ display: "inline-block", lineHeight: 0 }}
            >
              <Box
                component="img"
                src={`${backendURL}/image/thumbnail/${image.id}`}
                alt=""
                sx={{
                  display: "block",
                  bgcolor: "#fff",
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 1,
                  height: 140,
                  width: "auto",
                }}
              />
            </RouterLink>
            <Typography
              sx={{
                fontSize: "0.6875rem",
                color:
                  image.id === selectedImageID
                    ? "primary.main"
                    : "text.secondary",
                fontWeight: image.id === selectedImageID ? 700 : 400,
                textAlign: "center",
                mt: "3px",
              }}
            >
              {pictureLabel(image, data.source)}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default DiamondGallery;
